import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-item-handling-edit',
  templateUrl: './item-handling-edit.component.html',
  styleUrls: ['./item-handling-edit.component.scss']
})
export class ItemHandlingEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
